import { render, staticRenderFns } from "./course-categories.html?vue&type=template&id=7cc9b3d8&scoped=true&"
import script from "./course-categories.js?vue&type=script&lang=js&"
export * from "./course-categories.js?vue&type=script&lang=js&"
import style0 from "./course-categories.scss?vue&type=style&index=0&id=7cc9b3d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc9b3d8",
  null
  
)

export default component.exports